import envConstants from "~/config/envConstants";

import type { BoardLayout, EnvLayouts } from "./andonLayout.types";

export function pickEnv(envs: EnvLayouts): BoardLayout[] {
  switch (envConstants.RUNTIME_ENVIRONMENT) {
    case "production":
      return envs.production;
    case "staging":
      return envs.staging;
    case "qa":
      return envs.qa;
    case "uat":
      return envs.uat;
    default:
      return [];
  }
}
